import axios from "axios";
import { ACCESS_TOKEN_KEY } from "../helpers/constants";

const { REACT_APP_ENV, REACT_APP_PROD_API_HOST, REACT_APP_DEV_API_HOST } =
  process.env;

const http = axios.create({
  baseURL:
    REACT_APP_ENV === "production"
      ? REACT_APP_PROD_API_HOST
      : REACT_APP_DEV_API_HOST,
});

http.interceptors.request.use(
  async (config) => {
    if (
      config.url &&
      (config.url === "/api/v2/app/auth" ||
        config.url === "/api/v2/app/cliente/redefinir-senha/solicitar" ||
        config.url === "/api/v2/app/cliente/redefinir-senha/validar" ||
        config.url === "/api/v2/config?app" ||
        config.url === "/api/v2/app/cliente/redefinir-senha" ||
        config.url.startsWith("/api/v2/app/cliente/verificacao") ||
        (config.url === "/api/v2/app/cliente" &&
          config.method &&
          config.method === "post") ||
        (config.url.startsWith("/api/v2/app/plano/") &&
          config?.method === "get"))
    ) {
      return config;
    }

    const refreshTokenFromDatabase = localStorage.getItem(ACCESS_TOKEN_KEY);

    if (refreshTokenFromDatabase) {
      config.headers.Authorization = `Bearer ${refreshTokenFromDatabase}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default http;
